// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:12:07.486Z
// Property: Windy Shores (ID: 6737460151192642)
// Collections: 24 amenities, 10 floorplans (live), 32 photos, 61 POIs, 5 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151192642",
  "property_external_id": "5005725",
  "property_zillow_url": "https://www.zillow.com/b/windy-shores-aransas-pass-tx-5Xhsw3/",
  "property_apartments_url": "https://www.apartments.com/windy-shores-aransas-pass-tx/m3jg5zj",
  "property_google_business_url": "https://www.google.com/maps/place/Windy+Shores/data=!4m2!3m1!1s0x0:0xdcc176cc411479e4?sa=X&ved=2ahUKEwiZhfL0y7ySAxWbL9AFHXZWEw8Q_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321124211",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "windy-shores",
  "property_name": "Windy Shores",
  "property_website_url": "https://www.liveatwindyshores.com/",
  "property_domain": "https://www.liveatwindyshores.com/",
  "property_address": "2255 Mcmullen Ln",
  "property_full_address": "2255 McMullen Ln, Aransas Pass, TX 78336",
  "property_address_1": "2255 McMullen Ln",
  "property_address_2": null,
  "property_address_city": "Aransas Pass",
  "property_address_state": "TX",
  "property_address_zip_full": "78336-4638",
  "property_address_zip": "78336",
  "property_address_country": "US",
  "property_address_county": "San Patricio County",
  "property_neighborhood_address": "Downtown Ingleside",
  "property_address_latitude": "27.9117404",
  "property_address_longitude": "-97.1729651",
  "property_email": "windyshores@rrliving.com",
  "property_phone": "(361) 758-2840",
  "property_call_tracking_phone": "361-264-1281",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Windy Shores in Aransas Pass, TX! Choose from spacious two, three, or four-bedroom floor plans, all designed for comfort. Enjoy top-notch amenities, including a refreshing pool, modern fitness center, and a fun dog park. Find your new home today—browse our availability or schedule a tour!",
  "property_long_description": "Welcome to Windy Shores, your ultimate apartment living destination in the heart of Aransas Pass, TX! Discover our thoughtfully designed floor plans that cater to a variety of lifestyles, featuring spacious two-bedroom, three-bedroom, and four-bedroom apartments. Each home is designed with your comfort in mind, offering modern amenities and stylish finishes.\n\nAt Windy Shores, we believe in fostering a vibrant community. Dive into relaxation at our sparkling pool, break a sweat in our state-of-the-art fitness center, or enjoy quality time with friends at our welcoming clubhouse. Whether you're working remotely or need a place to study, our fully-equipped business center has you covered. For our furry friends, our on-site dog park provides the perfect space for play and exercise.\n\nConvenience is key, and with an elevator in our community, moving between floors is a breeze. Windy Shores truly offers a blend of comfort and community, making it the perfect place to call home. \n\nDon't miss out on the opportunity to experience all that Windy Shores has to offer. Find your new home today by browsing our availability or scheduling a tour to visit our exceptional community. Embrace a lifestyle of luxury and convenience at Windy Shores—your new beginning awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-a4f2-728f-a6bb-e4ec7841dda8.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of a two-story apartment building with a beige facade, a blue front door, and a two-car garage.",
    "public_id": "019e8494-a4f2-728f-a6bb-e4ec7841dda8",
    "storage_key": "property/6737460151192642/019e8494-a4f2-728f-a6bb-e4ec7841dda8.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "155",
  "property_year_built": "2003",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.32258064516128",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": null,
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://windyshores.loftliving.com/login",
  "property_apply_now_url": "https://8893272.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8495-1f77-7260-949c-ac7a970566ec.webp",
  "property_primary_logo_media": {
    "alt_text": "Windy Shores Townhome Rentals logo",
    "public_id": "019e8495-1f77-7260-949c-ac7a970566ec",
    "storage_key": "property/6737460151192642/019e8495-1f77-7260-949c-ac7a970566ec.webp",
    "width": 937,
    "height": 625
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8495-1f77-7260-949c-ac7a970566ec.webp",
  "property_secondary_logo_media": {
    "alt_text": "Windy Shores Townhome Rentals logo",
    "public_id": "019e8495-1f77-7260-949c-ac7a970566ec",
    "storage_key": "property/6737460151192642/019e8495-1f77-7260-949c-ac7a970566ec.webp",
    "width": 937,
    "height": 625
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8e86-f5b6-76f8-a88b-d53f28dc68ce.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e8e86-f5b6-76f8-a88b-d53f28dc68ce",
    "storage_key": "property/6737460151192642/019e8e86-f5b6-76f8-a88b-d53f28dc68ce.webp",
    "width": 937,
    "height": 625
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8e86-e8a6-7349-b707-45d65c6fab8a.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e8e86-e8a6-7349-b707-45d65c6fab8a",
    "storage_key": "property/6737460151192642/019e8e86-e8a6-7349-b707-45d65c6fab8a.webp",
    "width": 937,
    "height": 625
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#0d345e",
  "property_secondary_color": "#88a2bf",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "2 - 4",
  "property_bedrooms_min": "2",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2 - 3",
  "property_bathrooms_min": "2",
  "property_bathrooms_max": "3",
  "property_sqft_range": "1488 - 1798",
  "property_sqft_min": "1488",
  "property_sqft_max": "1798",
  "property_price_range": "1528 - 2214",
  "property_price_min": "1528",
  "property_price_max": "2214",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/people/Windy-Shores-Apartments/61554408144596/",
  "property_instagram_url": "https://www.instagram.com/windyshores_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJv5ZNChtSaIYR5HkUQcx2wdw",
  "property_youtube_url": "https://www.youtube.com/watch?v=puezmbthn-Q",
  "property_yelp_url": "https://www.yelp.com/biz/windy-shores-aransas-pass",
  "property_tiktok_url": "https://www.tiktok.com/@windy.shores",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Windy Shores",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "<p>When you use the private entrance to experience our spacious <a href=\"/floor-plans/\">two, three, and four-bedroom duplex-style townhomes</a>, you realize nobody lives above or below you; what an expansive feeling. Relish looking out your sliding glass window to see the littles playing with a small dog in your vast backyard. Appreciate bringing the groceries from your one-car garage into your gourmet-style, fully-equipped kitchen. Premium amenities abound, including abundant storage and a washer and dryer. Come to Windy Shores in Aransas Pass, TX, and experience the style and comfort you crave.</p>",
  "property_home_floorplans_blurb": "<p>Shed the apartment and check out our <a href=\"/floor-plans/\">duplex-styled townhomes for rent</a> with fenced-in backyards at Windy Shores in Aransas Pass, Texas. In an unbeatable location, you will enjoy living just around the corner from top-rated schools, military bases, and shopping. Easy access to US 181-S and TX 361-S makes the 20-minute commute to Corpus Christi a breeze. Explore the coast with its magnificent scenery and fun destinations. Call us to schedule an appointment today!</p>",
  "property_home_gallery_blurb": "Welcome to Windy Shores in Aransas Pass, TX, where comfort meets community. Choose from spacious two, three, or four-bedroom floor plans tailored for your lifestyle. Enjoy premium amenities like a refreshing pool, fitness center, and tennis court. Picture yourself living here and embrace a life of leisure and convenience!",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood surrounding Windy Shores in Aransas Pass, TX! Explore local favorites and nearby points of interest while enjoying spacious floor plans, including two, three, and four-bedroom apartments. Don’t miss out—see what’s around our community today and start your new adventure! ",
  "property_home_reviews_blurb": "Experience the vibrant atmosphere of Windy Shores Apartments in Aransas Pass, TX, where our dedicated team truly cares. As one resident puts it, “Amy has made so many positive changes… I am happy these changes have been made.” Join us and see why residents rave about our exceptional community!",
  "property_neighborhood_blurb": "<p>Shed the apartment and check out our <a href=\"/floor-plans/\">duplex-styled townhomes for rent</a> with fenced-in backyards at Windy Shores in Aransas Pass, Texas. In an unbeatable location, you will enjoy living just around the corner from top-rated schools, military bases, and shopping. Easy access to US 181-S and TX 361-S makes the 20-minute commute to Corpus Christi a breeze. Explore the coast with its magnificent scenery and fun destinations. Call us to schedule an appointment today!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Join our <a href=\"/neighborhood/\">townhome community</a> and immerse yourself in the luxurious amenities we provide. Take advantage of our resort-style swimming pool and 18-inch deep splash pool on hot summer days. Get fit utilizing the pickleball and basketball courts or our state-of-the-art fitness center. Small ones can burn off energy at our playground and tot lot. Socialize in the club room during resident events, or get some last-minute things accomplished in our on-site business center. Let our professional management team show you around Windy Shores townhomes in Aransas Pass, Texas, and you will want to call us \"home.\"</p>",
  "property_applynow_blurb": "Discover your ideal home at Windy Shores in Aransas Pass, TX! Choose from spacious two, three, and four-bedroom floor plans, complemented by premium amenities like a pool, fitness center, and dog park. Ready to elevate your lifestyle? Apply now and lease your perfect apartment online today!",
  "property_contactus_blurb": "Explore spacious floor plans at Windy Shores in Aransas Pass, TX. Choose from our inviting two, three, or four-bedroom apartments designed for comfort and style. Ready to find your new home? Have questions? Contact our leasing team today to learn more about your perfect fit!",
  "property_faqs_blurb": "Discover the perfect home at Windy Shores in Aransas Pass, TX, offering thoughtfully designed two, three, and four-bedroom floor plans. Have questions? Browse our FAQs page to find answers about our vibrant community, amenities, and more. Your ideal coastal living experience awaits!",
  "property_floorplans_blurb": "<p>Our oversized floor plans will exceed your expectations. Spacious, bright and complete with <a href=\"/amenities/\">indoor and outdoor amenities</a>, you can choose from two, three, or four bedroom townhome options in our prime location in Aransas Pass, TX.</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments</a>.</p>",
  "property_interactivemap_blurb": "Discover your ideal home at Windy Shores in Aransas Pass, TX! Choose from spacious two, three, or four-bedroom floor plans and enjoy top-notch amenities like a pool, fitness center, and dog park. Use our interactive community map to find available apartments, view pricing, and select your new home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Windy Shores in Aransas Pass, TX, we offer spacious two, three, and four-bedroom floor plans perfect for every lifestyle. Discover the charm of our vibrant community and enjoy great neighbors. Great friends make great neighbors—refer a friend to join us today! Experience the Windy Shores difference!",
  "property_residentaccess_blurb": "Welcome to Windy Shores in Aransas Pass, TX! Explore our spacious two, three, and four-bedroom floor plans designed for comfort and style. Ready to manage your living experience? Access your resident portal now to pay rent, schedule maintenance, and more—all with ease at your fingertips! ",
  "property_reviews_blurb": "At Windy Shores in Aransas Pass, TX, residents like one long-term tenant express their satisfaction: 'The atmosphere is so positive, and changes have been made.' With dedicated management and attentive maintenance, our community thrives. Join us and see why so many choose to call Windy Shores home!",
  "property_created_at": "1752257258614",
  "property_scheduletour_blurb": "Discover your perfect home at Windy Shores in Aransas Pass, TX! Choose from spacious two, three, or four-bedroom floor plans tailored for your lifestyle. Schedule a tour today and experience the vibrant community atmosphere. Curious about life here? See what our residents have to say about living at Windy Shores!",
  "property_thankyou_blurb": "Thank you for your interest in Windy Shores in Aransas Pass, TX! Explore our spacious two, three, and four-bedroom floor plans that cater to your lifestyle. A team member will reach out shortly to assist you in finding your perfect home. Stay tuned for updates and availability!",
  "property_virtualtours_blurb": "<p>Virtual tours are available at Windy Shores. Tour our Aransas Pass townhomes featuring modern 2, 3, and 4-bedroom layouts right from your device.</p>",
  "property_copyright": "2025 All Rights Reserved. Windy Shores",
  "property_seo_title_home": "Windy Shores | Apartments in Aransas Pass, TX",
  "property_seo_description_home": "Discover your dream apartment at Windy Shores in Aransas Pass, TX! Choose from spacious two, three, and four-bedroom floor plans designed for comfort. Enjoy top-notch amenities, including a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. Our community also features a dog park, business center, and convenient elevators. Find your new home today and embrace a lifestyle of convenience and leisure!",
  "property_seo_title_floorplans": "Floor Plans | 2 - 4 Apartments in Aransas Pass, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at Windy Shores in Aransas Pass, TX! Explore our diverse floor plans featuring spacious two-bedroom, three-bedroom, and four-bedroom apartments designed for comfort and style. Don't miss out—browse our available apartment homes today and find your perfect match!",
  "property_seo_title_amenities": "Amenities | Aransas Pass, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover Windy Shores in Aransas Pass, TX! Our stunning community offers spacious two, three, and four-bedroom floor plans designed for comfort. Enjoy exceptional amenities, including a refreshing pool, a state-of-the-art fitness center, a welcoming clubhouse, and a dedicated dog park for your furry friends. Plus, take advantage of our convenient business center and elevators for easy living. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Aransas Pass, TX",
  "property_seo_description_gallery": "Discover the beauty of Windy Shores in Aransas Pass, TX! Dive into our Photo Gallery to explore stunning visuals of our spacious two, three, and four-bedroom apartment floor plans. Enjoy top-notch amenities like our refreshing pool, state-of-the-art fitness center, clubhouse, and more. Your dream home awaits—picture yourself living here!",
  "property_seo_title_virtualtours": "Virtual Tours | Windy Shores Apartments",
  "property_seo_description_virtualtours": "Discover your ideal living space at Windy Shores in Aransas Pass, TX! Explore our stunning two, three, and four-bedroom floor plans and get a taste of our vibrant community. Take a virtual tour today and envision your new home by the coast. Don't miss out—experience the lifestyle you've been dreaming of!",
  "property_seo_title_interactivemap": "Interactive Map | Windy Shores Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Windy Shores in Aransas Pass, TX! Explore our spacious two, three, and four-bedroom floor plans, and enjoy top-notch amenities including a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. Whether you’re looking for a pet-friendly community with a dog park or a business center for work, we have everything you need. Use our interactive community map to search available apartments, view pricing, and select your new home today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Aransas Pass, TX",
  "property_seo_description_neighborhood": "Discover the vibrant lifestyle at Windy Shores in Aransas Pass, TX! Explore our two, three, and four-bedroom floor plans, and see what's around our community. From local favorites to nearby attractions, your next adventure is just a step away. Click to uncover the best of neighborhood living!",
  "property_seo_title_contact": "Contact Us | Windy Shores",
  "property_seo_description_contact": "Discover your ideal home at Windy Shores in Aransas Pass, TX! Explore our spacious two, three, and four-bedroom floor plans designed for comfort and style. Have questions? Contact our leasing team today to find your perfect apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in Aransas Pass, TX",
  "property_seo_description_faqs": "Discover the lifestyle you deserve at Windy Shores in Aransas Pass, TX! Explore our FAQs page for essential information about our spacious two, three, and four-bedroom floor plans, and learn about our exceptional amenities including a refreshing pool, fitness center, and dog park. Have questions? We have answers—browse our FAQs now!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Aransas Pass, TX",
  "property_seo_description_reviews": "Discover what residents love about Windy Shores in Aransas Pass, TX! From spacious two, three, and four-bedroom floor plans to top-notch amenities like a pool, fitness center, clubhouse, and dog park, our community has it all. Don’t just take our word for it—see what our residents have to say! Come explore the perfect combination of comfort and convenience today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Aransas Pass, TX",
  "property_seo_description_applynow": "Discover your ideal living space at Windy Shores in Aransas Pass, TX! Explore our spacious two, three, and four-bedroom floor plans designed for comfort and style. Enjoy a range of exceptional amenities including a refreshing pool, state-of-the-art fitness center, and a welcoming clubhouse. With a dedicated dog park and convenient business center, you’ll find everything you need just steps from your door. Don’t wait—find your new home and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Windy Shores",
  "property_seo_description_residentaccess": "\"Welcome to the Windy Shores Resident Access Portal! Conveniently pay rent, schedule maintenance, and manage your apartment needs all in one place. Join our vibrant Aransas Pass community today!\"",
  "property_seo_title_referafriend": "Refer A Friend | Windy Shores",
  "property_seo_description_referafriend": "\"Refer a friend to Windy Shores in Aransas Pass, TX, and enjoy exclusive rewards! Great friends make great neighbors—spread the word about our vibrant community and all its amazing amenities. Join us today!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Windy Shores",
  "property_seo_description_scheduletour": "\"Discover your dream home at Windy Shores in Aransas Pass, TX! Experience coastal living at its finest with stunning amenities and breathtaking views. Schedule a tour of our community today to explore your future home!\"",
  "property_seo_title_privacy": "Privacy Policy | Windy Shores",
  "property_seo_description_privacy": "Discover how Windy Shores in Aransas Pass, TX prioritizes your privacy. Learn about our commitment to safeguarding your personal information and transparency in our practices. View our privacy policy for more details!",
  "property_seo_title_accessibility": "Website Accessibility | Windy Shores",
  "property_seo_description_accessibility": "\"Explore Windy Shores in Aransas Pass, TX, where we prioritize accessibility for all. Our commitment to digital inclusion ensures everyone can discover their ideal home. Learn more about our accessibility features and join our welcoming community today!\"",
  "property_seo_title_sitemap": "Sitemap | Windy Shores",
  "property_seo_description_sitemap": "Explore Windy Shores in Aransas Pass, TX! Our sitemap offers a comprehensive overview of our apartment community, amenities, and nearby attractions. Discover what makes Windy Shores the perfect place to call home. View our website sitemap today!",
  "property_seo_title_thankyou": "Thank You | Windy Shores",
  "property_seo_description_thankyou": "Thank you for reaching out to Windy Shores in Aransas Pass, TX! We appreciate your interest. A member of our friendly team will be in touch shortly to assist you. Explore the charm and comfort of our community, where your dream apartment awaits!",
  "property_seo_title_pets": "Pet Policy | Apartments in Aransas Pass, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293558524",
  "amenities": [
    {
      "id": "custom_90c278c4-dc23-4d72-b95c-1716ec62b909",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Resort‑style Swimming Pool and Splash Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b8dd6d1d-a1bf-4b53-8690-e70399ea2daa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_51e327ba-ee63-4fd3-82e5-3cf2fddac7d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Basketball Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc802c65-4914-4346-9cb7-00b627371c3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_989127d4-4b17-4794-afd6-5cecd52b6b85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_653cb65b-40d0-46ea-9f8a-687b8dd9aa6c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Clubhouse with Gourmet Kitchen",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cad0059d-2267-4ee6-a53d-9f71123d0f1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fec5604f-302f-442c-94d5-91775fb0444f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64da8a5b-4049-4565-a6a4-4f8ab2126075",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Freeways",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67fd9173-abb7-4a0c-bd49-679dd602d632",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Shopping and Walkable Schools",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fe588691-1b93-4dd5-8074-75986a6b3b8e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Large Open Grassy Areas",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0a6af6a-f344-4c46-abf5-dccca2e0f860",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Attached One Car Garage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7e1b314-f77a-453d-91af-e46d7b4109c6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Ceramic Tile in Entry Way, Kitchen and Baths",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ad9fd9c4-cb79-473e-b1a3-bb857cc64da8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1557588e-6245-4670-9058-7f5f7865339d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Fenced Backyard",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_67ddde22-996f-4da3-b1e1-7d13d7ffa967",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Gourmet Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0ab066ea-f069-4d2e-b11e-84bfc29a183f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Large Walk‑in Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_fa79758f-6232-4253-8363-215b1176c7a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Plush Carpeting Upstairs",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d75d9670-40e5-449b-8698-53aa36498c17",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_df0def8e-e7c5-40d5-b1e9-d2f39b9a134f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Countertops",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_68d77cbb-b8f6-46f4-ad3a-a013b235fb64",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Spacious Floor Plans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_24d70f71-06eb-4098-9a92-a0cbc6283b05",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_89f6bf85-0316-45c2-b096-9eeab3086c4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections in Unit",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_694a3035-5754-43a9-b6fb-c5755f3da997",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑style Flooring Downstairs",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3bcf5b05-2413-487f-bcef-d3e5e0bae6a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-a4f2-728f-a6bb-e4ec7841dda8.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story apartment building with a beige facade, a blue front door, and a two-car garage.",
        "public_id": "019e8494-a4f2-728f-a6bb-e4ec7841dda8",
        "storage_key": "property/6737460151192642/019e8494-a4f2-728f-a6bb-e4ec7841dda8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming two-story apartment home featuring a welcoming entrance, a two-car garage, and a beautiful blooming tree.",
      "link": "",
      "alt_text": "Exterior of a two-story apartment building with a beige facade, a blue front door, and a two-car garage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e611b28c-49af-4961-8f1d-26bf7eb6c6a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-beff-7148-95e9-c0db5d5738ad.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables, fenced area.",
        "public_id": "019e8494-beff-7148-95e9-c0db5d5738ad",
        "storage_key": "property/6737460151192642/019e8494-beff-7148-95e9-c0db5d5738ad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, complete with comfortable seating areas for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables, fenced area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_442e917d-1981-4b9a-b40e-a798574bdb59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-a4e2-723c-869e-bcc052cb1d14.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and television.",
        "public_id": "019e8494-a4e2-723c-869e-bcc052cb1d14",
        "storage_key": "property/6737460151192642/019e8494-a4e2-723c-869e-bcc052cb1d14.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this spacious living room, featuring a comfortable sectional sofa, a modern coffee table, and a large television for entertainment.",
      "link": "",
      "alt_text": "Living room with a sectional sofa, coffee table, and television.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d049c1fb-37c6-4837-8d47-2def34eca5b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-eb92-7798-8023-b5ba0713e049.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment living room with a ceiling fan, a window, and a front door.",
        "public_id": "019e8494-eb92-7798-8023-b5ba0713e049",
        "storage_key": "property/6737460151192642/019e8494-eb92-7798-8023-b5ba0713e049.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area in an apartment, featuring dark wood-look flooring, a ceiling fan for comfort, and a bright window. Includes a view of the entryway with a white door.",
      "link": "",
      "alt_text": "Interior view of an empty apartment living room with a ceiling fan, a window, and a front door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2afb5df7-821f-4264-98af-6136f5d0b0e1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-eb66-76f6-ad4a-1804170bf2bd.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, weight machines, dumbbells, and exercise balls.",
        "public_id": "019e8494-eb66-76f6-ad4a-1804170bf2bd",
        "storage_key": "property/6737460151192642/019e8494-eb66-76f6-ad4a-1804170bf2bd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines, free weights, and a variety of exercise equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with treadmills, weight machines, dumbbells, and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4e2c2074-61b8-4a58-9f9d-e16f2132ec27",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-eb5c-774b-ae0a-063c0d35d6eb.webp",
      "image_media": {
        "alt_text": "Swimming pool with a playground in the background.",
        "public_id": "019e8494-eb5c-774b-ae0a-063c0d35d6eb",
        "storage_key": "property/6737460151192642/019e8494-eb5c-774b-ae0a-063c0d35d6eb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing on a sunny day. A fun playground is also nearby for the little ones.",
      "link": "",
      "alt_text": "Swimming pool with a playground in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a4c8a66-c9dd-4d44-bde0-81f0a525b02b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-eb86-728a-8dc8-7bffb8c66337.webp",
      "image_media": {
        "alt_text": "Empty apartment living room with dark wood floors and blinds on windows.",
        "public_id": "019e8494-eb86-728a-8dc8-7bffb8c66337",
        "storage_key": "property/6737460151192642/019e8494-eb86-728a-8dc8-7bffb8c66337.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area in this apartment, featuring large windows with blinds and dark wood flooring.",
      "link": "",
      "alt_text": "Empty apartment living room with dark wood floors and blinds on windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_34eb1ce0-26cf-4f5f-b918-2ad5995c02da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8495-1e26-77c3-8ef2-30fd56e3d0a9.webp",
      "image_media": {
        "alt_text": "Living room and stairs in an apartment.",
        "public_id": "019e8495-1e26-77c3-8ef2-30fd56e3d0a9",
        "storage_key": "property/6737460151192642/019e8495-1e26-77c3-8ef2-30fd56e3d0a9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with wood-look flooring and a carpeted staircase leading to the second floor.",
      "link": "",
      "alt_text": "Living room and stairs in an apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_487e75f4-14e3-496c-9f6e-4f30d8b89f49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8495-1e4d-7766-95dc-54856df3501c.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan, closet, and large window",
        "public_id": "019e8495-1e4d-7766-95dc-54856df3501c",
        "storage_key": "property/6737460151192642/019e8495-1e4d-7766-95dc-54856df3501c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, ample closet space, and a large window for natural light.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan, closet, and large window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c592e6cd-db88-4daa-9e25-7c6abe0bb46c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8495-0ef1-7118-9c7a-e02f41ffc299.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and a large window.",
        "public_id": "019e8495-0ef1-7118-9c7a-e02f41ffc299",
        "storage_key": "property/6737460151192642/019e8495-0ef1-7118-9c7a-e02f41ffc299.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and a large window, perfect for natural light.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_19cbb236-deee-4667-9812-05393ed7e598",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8495-1c8e-776a-beb7-569a773e8d0a.webp",
      "image_media": {
        "alt_text": "Clean bathroom with a white toilet, vanity with granite countertop, and a round mirror.",
        "public_id": "019e8495-1c8e-776a-beb7-569a773e8d0a",
        "storage_key": "property/6737460151192642/019e8495-1c8e-776a-beb7-569a773e8d0a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A modern and clean bathroom featuring a white toilet, a vanity with a granite countertop and sink, and a stylish round mirror above the vanity.",
      "link": "",
      "alt_text": "Clean bathroom with a white toilet, vanity with granite countertop, and a round mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a0b7ab7-4c43-475b-bdf0-37a260d820e9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8495-1f3b-752b-aec5-e46d38bd9b7d.webp",
      "image_media": {
        "alt_text": "Bathroom with a granite countertop vanity, oval mirror, and white bathtub and toilet.",
        "public_id": "019e8495-1f3b-752b-aec5-e46d38bd9b7d",
        "storage_key": "property/6737460151192642/019e8495-1f3b-752b-aec5-e46d38bd9b7d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a clean and well-appointed bathroom featuring a spacious vanity with a granite countertop, an oval mirror, and a pristine white bathtub and toilet.",
      "link": "",
      "alt_text": "Bathroom with a granite countertop vanity, oval mirror, and white bathtub and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_da0756b1-6aa8-41c3-b412-6a47f83da3aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8495-2073-73cf-b0b5-204b2d65ee2d.webp",
      "image_media": {
        "alt_text": "Empty garage with open door and storage shelves.",
        "public_id": "019e8495-2073-73cf-b0b5-204b2d65ee2d",
        "storage_key": "property/6737460151192642/019e8495-2073-73cf-b0b5-204b2d65ee2d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious, clean garage with an automatic door opener and built-in shelving for storage.",
      "link": "",
      "alt_text": "Empty garage with open door and storage shelves.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a171c4e4-58f4-4a63-9454-c026b4dfc357",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-b94d-7008-88f6-feba68c19db8.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with garages and green lawns.",
        "public_id": "019e8494-b94d-7008-88f6-feba68c19db8",
        "storage_key": "property/6737460151192642/019e8494-b94d-7008-88f6-feba68c19db8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment exteriors featuring attached garages and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with garages and green lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec28e458-f19d-4428-a13b-af402ef425a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-a1dd-75bc-b1c4-ff37701a56a7.webp",
      "image_media": {
        "alt_text": "Tennis courts with nets and apartment buildings in the background.",
        "public_id": "019e8494-a1dd-75bc-b1c4-ff37701a56a7",
        "storage_key": "property/6737460151192642/019e8494-a1dd-75bc-b1c4-ff37701a56a7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a friendly match on our tennis courts, perfect for exercise and recreation.",
      "link": "",
      "alt_text": "Tennis courts with nets and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_674486df-c9f9-4ef2-a3d9-de4e24fa4fb9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-b3f2-7709-b438-d28221460ec4.webp",
      "image_media": {
        "alt_text": "Exterior view of a tan stucco duplex with a red front door and a two-car garage.",
        "public_id": "019e8494-b3f2-7709-b438-d28221460ec4",
        "storage_key": "property/6737460151192642/019e8494-b3f2-7709-b438-d28221460ec4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming tan stucco duplex featuring a welcoming red front door, manicured lawn, and a convenient two-car garage. Perfect for comfortable living.",
      "link": "",
      "alt_text": "Exterior view of a tan stucco duplex with a red front door and a two-car garage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1415d3a-3765-4311-a0f3-65900fe9f593",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8495-0f7b-708e-8124-f467c15a066d.webp",
      "image_media": {
        "alt_text": "Stationary bikes in a gym.",
        "public_id": "019e8495-0f7b-708e-8124-f467c15a066d",
        "storage_key": "property/6737460151192642/019e8495-0f7b-708e-8124-f467c15a066d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Our state-of-the-art fitness center features modern stationary bikes to help you stay active and energized.",
      "link": "",
      "alt_text": "Stationary bikes in a gym.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_517af79b-4f31-42f1-98c6-d2605cf8e72b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-fb3b-754f-bd89-36ef040df550.webp",
      "image_media": {
        "alt_text": "Spacious walk-in closet with shelves and hanging rods.",
        "public_id": "019e8494-fb3b-754f-bd89-36ef040df550",
        "storage_key": "property/6737460151192642/019e8494-fb3b-754f-bd89-36ef040df550.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Organize your belongings with ease in this generous walk-in closet, featuring ample shelving and hanging space.",
      "link": "",
      "alt_text": "Spacious walk-in closet with shelves and hanging rods.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_290f1f2a-2e01-43a5-8297-a6994f107c2f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-ebf5-7369-833a-0a09528ef29c.webp",
      "image_media": {
        "alt_text": "Interior view of a vacant apartment living room with dark wood laminate flooring, a staircase, and a large window.",
        "public_id": "019e8494-ebf5-7369-833a-0a09528ef29c",
        "storage_key": "property/6737460151192642/019e8494-ebf5-7369-833a-0a09528ef29c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with dark wood floors, a convenient staircase, and abundant natural light from a large window. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Interior view of a vacant apartment living room with dark wood laminate flooring, a staircase, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb7da6dc-d548-4552-a1de-210a060b5d9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-eaf7-74fb-ae9b-117c716aa466.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, closet, and a large window.",
        "public_id": "019e8494-eaf7-74fb-ae9b-117c716aa466",
        "storage_key": "property/6737460151192642/019e8494-eaf7-74fb-ae9b-117c716aa466.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan for comfort, a convenient closet, and a large window that lets in plenty of natural light.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan, closet, and a large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8b3cbc28-ee24-4968-afd8-21cdfdb1d5ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-eaec-701c-be32-8c63ac3c8000.webp",
      "image_media": {
        "alt_text": "Laundry hookups and shelving in a small room with double doors.",
        "public_id": "019e8494-eaec-701c-be32-8c63ac3c8000",
        "storage_key": "property/6737460151192642/019e8494-eaec-701c-be32-8c63ac3c8000.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment features a dedicated space with hookups for a washer and dryer, along with overhead shelving for storage.",
      "link": "",
      "alt_text": "Laundry hookups and shelving in a small room with double doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5895f815-645a-4b1f-ae81-91344583a1b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-f603-749f-977d-46808b8629e5.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and a large window with blinds.",
        "public_id": "019e8494-f603-749f-977d-46808b8629e5",
        "storage_key": "property/6737460151192642/019e8494-f603-749f-977d-46808b8629e5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and a large window, offering ample natural light. Perfect for creating your personal sanctuary.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and a large window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9f97c821-ca28-4a54-8aaa-ec62a29b5fff",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-f32f-72d9-8679-35095719848b.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and neutral carpet.",
        "public_id": "019e8494-f32f-72d9-8679-35095719848b",
        "storage_key": "property/6737460151192642/019e8494-f32f-72d9-8679-35095719848b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring soft neutral carpeting and a modern ceiling fan for comfort and style.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and neutral carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0046b50c-6f6a-4b67-8c05-7b2903b1a91a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-d960-743f-9584-56822aa963b6.webp",
      "image_media": {
        "alt_text": "Seating area in a community lounge with sofas and a coffee table.",
        "public_id": "019e8494-d960-743f-9584-56822aa963b6",
        "storage_key": "property/6737460151192642/019e8494-d960-743f-9584-56822aa963b6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in the comfortable community lounge, featuring plush seating and a coffee table.",
      "link": "",
      "alt_text": "Seating area in a community lounge with sofas and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_12cb8e63-5de9-4d16-b325-b4f08d2018c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-d321-7038-9ee5-6f7417410a94.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019e8494-d321-7038-9ee5-6f7417410a94",
        "storage_key": "property/6737460151192642/019e8494-d321-7038-9ee5-6f7417410a94.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring stainless steel appliances, ample white cabinetry, and beautiful granite countertops. Includes a convenient walk-in pantry.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab567517-0aab-4f6b-863f-2953e32d50fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-d35b-733a-b792-8c9186aff414.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity and shower/tub combo",
        "public_id": "019e8494-d35b-733a-b792-8c9186aff414",
        "storage_key": "property/6737460151192642/019e8494-d35b-733a-b792-8c9186aff414.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops and a convenient shower/tub combination.",
      "link": "",
      "alt_text": "Bathroom with double vanity and shower/tub combo",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7b42528b-a508-4cca-8567-f86751b2e9d3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-c363-70e5-aa29-f898861278a9.webp",
      "image_media": {
        "alt_text": "Conference room with a glass table, white chairs, and a wall-mounted TV.",
        "public_id": "019e8494-c363-70e5-aa29-f898861278a9",
        "storage_key": "property/6737460151192642/019e8494-c363-70e5-aa29-f898861278a9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Conduct meetings or host study groups in our professional conference room, complete with a large table, comfortable seating, and modern technology.",
      "link": "",
      "alt_text": "Conference room with a glass table, white chairs, and a wall-mounted TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f0c621ff-30d3-4427-aa5e-ca3368050087",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-a132-713d-b316-b12f7fb9dcd2.webp",
      "image_media": {
        "alt_text": "Lobby seating area with wicker chairs, a coffee table, and a popcorn machine.",
        "public_id": "019e8494-a132-713d-b316-b12f7fb9dcd2",
        "storage_key": "property/6737460151192642/019e8494-a132-713d-b316-b12f7fb9dcd2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable lobby, complete with plush seating, a coffee table, and a fun popcorn machine for a classic treat.",
      "link": "",
      "alt_text": "Lobby seating area with wicker chairs, a coffee table, and a popcorn machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_22ef4774-702c-427a-9809-cb9b69bf462f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-a379-713e-90d7-6ac8b08e937c.webp",
      "image_media": {
        "alt_text": "Swimming pool with palm trees and residential buildings in the background",
        "public_id": "019e8494-a379-713e-90d7-6ac8b08e937c",
        "storage_key": "property/6737460151192642/019e8494-a379-713e-90d7-6ac8b08e937c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating areas. A perfect spot to relax and unwind.",
      "link": "",
      "alt_text": "Swimming pool with palm trees and residential buildings in the background",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_94094670-9675-4b3f-8a9e-7f3e7698c8f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-a06c-77aa-97ce-bf4f54338a9b.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with palm trees and residential buildings in the background.",
        "public_id": "019e8494-a06c-77aa-97ce-bf4f54338a9b",
        "storage_key": "property/6737460151192642/019e8494-a06c-77aa-97ce-bf4f54338a9b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush palm trees and scenic views.",
      "link": "",
      "alt_text": "Outdoor swimming pool with palm trees and residential buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_90dc24e2-b2fb-4703-b15e-7d60583a4b6c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-9fc6-75f4-baae-db5cba51f087.webp",
      "image_media": {
        "alt_text": "Exterior view of townhomes with garages and red front doors.",
        "public_id": "019e8494-9fc6-75f4-baae-db5cba51f087",
        "storage_key": "property/6737460151192642/019e8494-9fc6-75f4-baae-db5cba51f087.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Townhome exterior featuring attached garages, a welcoming red front door, and well-maintained landscaping.",
      "link": "",
      "alt_text": "Exterior view of townhomes with garages and red front doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_79d2fc36-2ddc-4bf8-b361-7a3d6214f731",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e8494-a3b6-7594-8a47-7479b7ef5e31.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and tables, surrounded by a white fence and palm trees.",
        "public_id": "019e8494-a3b6-7594-8a47-7479b7ef5e31",
        "storage_key": "property/6737460151192642/019e8494-a3b6-7594-8a47-7479b7ef5e31.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing or socializing on a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and tables, surrounded by a white fence and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_99a52634-0ce6-4c31-a602-4b2ffe49fe28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Coasters",
      "poi_type": "Restaurants",
      "poi_address": "320 Huff St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Casual eatery offering a menu that includes chicken and waffles plus beer and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-07c9-710d-b39c-a64df49608a6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-07c9-710d-b39c-a64df49608a6",
        "storage_key": "property/6737460151192642/019e1dda-07c9-710d-b39c-a64df49608a6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://coastersaptx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14794946524876324328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coasters",
      "poi_latitude": "27.9114746",
      "poi_longitude": "-97.1341523",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 361-226-1437",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff15-76ec-becc-a5c1849c764d",
        "storage_key": "property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIXtnOvZTaIYR6D0nNno1Us0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d1469e2a-70a1-447d-8b31-a4a0a1b9468c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Dorado's Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "518 Bigelow St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Casual bar and restaurant serving tacos, fried seafood and burgers in an open-air setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-71b7-772d-86ac-a6d19ed3b688.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-71b7-772d-86ac-a6d19ed3b688",
        "storage_key": "property/6737460151192642/019e1ddc-71b7-772d-86ac-a6d19ed3b688.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17318955705301170463&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dorados-restaurant--bar",
      "poi_latitude": "27.9007747",
      "poi_longitude": "-97.1366317",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 361-758-6244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff22-7238-9518-45cd02291c2f",
        "storage_key": "property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDzsRfG9TaIYRH3kzR3RKWfA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_e8f6838e-be44-4eee-ab4e-1fe021d9c5df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Crab-N Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "210 Gulf Gate Rd, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Family-owned bar and grill offering from-scratch seafood dishes and a selection of beer, wine, and cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-70ad-76d2-9193-00aae506e6ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-70ad-76d2-9193-00aae506e6ab",
        "storage_key": "property/6737460151192642/019e1ddc-70ad-76d2-9193-00aae506e6ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.crab-n.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10912496774736136656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crab-n-restaurant",
      "poi_latitude": "27.9515896",
      "poi_longitude": "-97.1082173",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 361-758-2371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff15-76ec-becc-a5c1849c764d",
        "storage_key": "property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgasL6jlNaIYR0Em-7v_5cJc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fd98bbb1-738a-49a8-ba2e-cacc8e82ee9f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Mickey's Bar and Grill",
      "poi_type": "Restaurants",
      "poi_address": "430 Ransom Rd, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Down-to-earth waterfront eatery with marina views, preparing seafood, steaks & other classic bites.",
      "poi_long_description": "Down-to-earth waterfront eatery with marina views, preparing seafood, steaks & other classic bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-045f-73bd-8ec1-1a7c2bd51b4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-045f-73bd-8ec1-1a7c2bd51b4b",
        "storage_key": "property/6737460151192642/019e1dda-045f-73bd-8ec1-1a7c2bd51b4b.webp",
        "width": 750,
        "height": 497
      },
      "poi_business_url": "http://www.facebook.com/MickeysBarGrillatHamptonsLanding/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13948409277024989654&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mickeys-bar-and-grill",
      "poi_latitude": "27.89",
      "poi_longitude": "-97.1486111",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 361-758-1562",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff22-7238-9518-45cd02291c2f",
        "storage_key": "property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBSvDA09SaIYR1nHW6lW0ksE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_af6d3bbc-c1b4-4e55-9d53-e3c216173fbb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Olde Towne Cafe",
      "poi_type": "Restaurants",
      "poi_address": "406 S Commercial St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-70ae-774d-87bc-3663cf84cc89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-70ae-774d-87bc-3663cf84cc89",
        "storage_key": "property/6737460151192642/019e1ddc-70ae-774d-87bc-3663cf84cc89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/profile.php?id=162458851135175&ref=content_filter",
      "poi_directions_map_url": "https://maps.google.com/?cid=17763983291266914166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olde-towne-cafe",
      "poi_latitude": "27.9023823",
      "poi_longitude": "-97.1465898",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-226-1169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddd-16f1-76a8-bfbb-a8324c733972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-16f1-76a8-bfbb-a8324c733972",
        "storage_key": "property/6737460151192642/019e1ddd-16f1-76a8-bfbb-a8324c733972.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ8yHxuW1TaIYRdlfwj69YhvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_5ac493ca-1c1c-4105-a66f-49f22d35fd9b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Taco De Oro Restaurant LLC",
      "poi_type": "Restaurants",
      "poi_address": "324 N Commercial St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-7042-70a1-acf3-0bc5f23a6b90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-7042-70a1-acf3-0bc5f23a6b90",
        "storage_key": "property/6737460151192642/019e1ddc-7042-70a1-acf3-0bc5f23a6b90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://order.tbdine.com/pickup/45885/menu",
      "poi_directions_map_url": "https://maps.google.com/?cid=5168273619911475330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taco-de-oro-restaurant-llc",
      "poi_latitude": "27.908994",
      "poi_longitude": "-97.141991",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-226-1239",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff15-76ec-becc-a5c1849c764d",
        "storage_key": "property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ935npWZSaIYRgoDYgHlluUc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_38871c0e-c1bd-4a0a-8e11-005c3ed278ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "San Juan Restaurant Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "922 S Commercial St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Casual spot for Tex-Mex dishes and a full bar, plus drive-thru service, and a kids' menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-778f-7063-ade0-78f7e2e62ef1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-778f-7063-ade0-78f7e2e62ef1",
        "storage_key": "property/6737460151192642/019e1ddc-778f-7063-ade0-78f7e2e62ef1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://app.justamenu.com/rr/san-juan-grill-and-restaurant-d12ic3feloczu0pu",
      "poi_directions_map_url": "https://maps.google.com/?cid=5704859993665773602&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "san-juan-restaurant-bar--grill",
      "poi_latitude": "27.896677",
      "poi_longitude": "-97.1506",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-226-1011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff15-76ec-becc-a5c1849c764d",
        "storage_key": "property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJISA_aURSaIYRIiDJR_C7K08",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_bfe7962d-35ba-401e-9e71-5be960dcf41e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Butter Churn",
      "poi_type": "Restaurants",
      "poi_address": "1275 Hwy 35 Bypass, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Casual, family-friendly eatery featuring a buffet of country-style cooking and Texas eats, as well as desserts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-03ea-70ac-9628-7ac8d1640064.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-03ea-70ac-9628-7ac8d1640064",
        "storage_key": "property/6737460151192642/019e1dda-03ea-70ac-9628-7ac8d1640064.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://butterchurn.thebumpcard.me/?y_source=1_MTAyMTk2OTk4NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12037994551342327468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "butter-churn",
      "poi_latitude": "27.9217285",
      "poi_longitude": "-97.1637813",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-758-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff15-76ec-becc-a5c1849c764d",
        "storage_key": "property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6_i9TGZSaIYRrObYsEOMD6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_779a7fed-8d35-4a24-bb1f-e927eae683c0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "2737 W Wheeler Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-0788-70aa-8e57-505980ac059d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-0788-70aa-8e57-505980ac059d",
        "storage_key": "property/6737460151192642/019e1dda-0788-70aa-8e57-505980ac059d.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://whataburger.com/menu?unitNum=14",
      "poi_directions_map_url": "https://maps.google.com/?cid=3827084581739657931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "27.9250981",
      "poi_longitude": "-97.1784259",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-758-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff15-76ec-becc-a5c1849c764d",
        "storage_key": "property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx6sHNGxSaIYRy3r3eyaJHDU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_fa1ad1aa-512d-4bf0-a8a4-d09214ab2ca6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "140 FM 1069, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-77bc-75b7-87e6-8cda1f96506e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-77bc-75b7-87e6-8cda1f96506e",
        "storage_key": "property/6737460151192642/019e1ddc-77bc-75b7-87e6-8cda1f96506e.webp",
        "width": 1280,
        "height": 717
      },
      "poi_business_url": "https://www.starbucks.ca/store-locator/store/1031535/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11446264040648756489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "27.92416",
      "poi_longitude": "-97.17784",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 361-900-0239",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddd-16f1-76a8-bfbb-a8324c733972.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-16f1-76a8-bfbb-a8324c733972",
        "storage_key": "property/6737460151192642/019e1ddd-16f1-76a8-bfbb-a8324c733972.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ8cPmR0pTaIYRCU0yBIBM2Z4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_7be45f92-19c3-467b-82e9-2cd0ba0ae77a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Taqueria Guadalajara",
      "poi_type": "Restaurants",
      "poi_address": "525 S Commercial St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Casual restaurant with a drive-thru serving Mexican fare such as fajitas and enchiladas, plus breakfast.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-709f-74fb-95f8-4cea2e032b22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-709f-74fb-95f8-4cea2e032b22",
        "storage_key": "property/6737460151192642/019e1ddc-709f-74fb-95f8-4cea2e032b22.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.taqueriaguadalajara.info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7129880301218742339&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "taqueria-guadalajara",
      "poi_latitude": "27.9006694",
      "poi_longitude": "-97.1470792",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-758-0222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff15-76ec-becc-a5c1849c764d",
        "storage_key": "property/6737460151192642/019e1dda-ff15-76ec-becc-a5c1849c764d.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL2T5LkBTaIYRQ8AytVts8mI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_2897e9dc-add4-418d-9a3d-d088ad23ea95",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Hook & Ladder Brewpub",
      "poi_type": "Restaurants",
      "poi_address": "130 E Goodnight Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-76cd-71db-83df-8e4fa15dbdb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-76cd-71db-83df-8e4fa15dbdb6",
        "storage_key": "property/6737460151192642/019e1ddc-76cd-71db-83df-8e4fa15dbdb6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1235548536164586077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hook--ladder-brewpub",
      "poi_latitude": "27.9022445",
      "poi_longitude": "-97.1452407",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff22-7238-9518-45cd02291c2f",
        "storage_key": "property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_cVGolTaIYRXRLY8NiMJRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_ddd1281d-4281-45ac-88ac-c5c7b336b386",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "NAPA Auto Parts - Third Coast Distributing Aransas Pass",
      "poi_type": "Shopping & Retail",
      "poi_address": "2252 W Wheeler Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Chain retailer offering a range of parts and accessories for cars, trucks, and marine vehicles.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-760c-7398-8113-5177b768d847.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-760c-7398-8113-5177b768d847",
        "storage_key": "property/6737460151192642/019e1ddc-760c-7398-8113-5177b768d847.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.napaonline.com/en/TX/Aransas-Pass/store/26604?cid=pl_jobber_google_dac_26604_ao",
      "poi_directions_map_url": "https://maps.google.com/?cid=13035508416022860544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "napa-auto-parts---third-coast-distributing-aransas-pass",
      "poi_latitude": "27.922575",
      "poi_longitude": "-97.1717119",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 361-758-7516",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYVeEtBJSaIYRAFOo29Zt57Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auto_parts_store"
    },
    {
      "id": "custom_4080e70a-cb3c-44c8-86fc-77dd53d38c00",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2501 W Wheeler Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Department store chain stocking a wide selection of merchandise, including home goods, furniture, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-7c5b-77fe-9071-76d17c978717.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-7c5b-77fe-9071-76d17c978717",
        "storage_key": "property/6737460151192642/019e1ddc-7c5b-77fe-9071-76d17c978717.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/458-aransas-pass-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12601480928758996073&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "27.9225496",
      "poi_longitude": "-97.1761874",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 361-758-2920",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVdNurAFSaIYRaRyKoiN04a4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_9deba430-6591-40e0-9f8f-1c8dad8bfedd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "H-E-B",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 E Goodnight Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-0466-7520-9e6c-f3d5c9409540.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-0466-7520-9e6c-f3d5c9409540",
        "storage_key": "property/6737460151192642/019e1dda-0466-7520-9e6c-f3d5c9409540.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/aransas-pass/aransas-pass-h-e-b-333?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=13601071977509702425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b",
      "poi_latitude": "27.901272",
      "poi_longitude": "-97.146059",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-758-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff7a-757d-bf16-ff586f3aef67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff7a-757d-bf16-ff586f3aef67",
        "storage_key": "property/6737460151192642/019e1dda-ff7a-757d-bf16-ff586f3aef67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKTWdOF1SaIYRGUv85-a2wLw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_fd84b21e-5e30-491b-951a-3456b909b5d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "2702 W Wheeler Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-7c67-73be-ab95-a9e5a3f0d1f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-7c67-73be-ab95-a9e5a3f0d1f6",
        "storage_key": "property/6737460151192642/019e1ddc-7c67-73be-ab95-a9e5a3f0d1f6.webp",
        "width": 1280,
        "height": 568
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2702+w+wheeler+ave-aransas+pass-tx-78336/id=10680",
      "poi_directions_map_url": "https://maps.google.com/?cid=12833529543003827577&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "27.9256161",
      "poi_longitude": "-97.1769047",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-758-2135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJPQLHdf9NaIYReW052R_bGbI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_51551b10-328d-4b58-a34e-9b51153cfe60",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Tractor Supply Co.",
      "poi_type": "Shopping & Retail",
      "poi_address": "1920 W Wheeler Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Chain with a wide variety of agricultural & livestock supplies, plus tools, workwear & boots.",
      "poi_long_description": "Chain with a wide variety of agricultural & livestock supplies, plus tools, workwear & boots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-80cf-76ad-b3be-846abc806ed4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-80cf-76ad-b3be-846abc806ed4",
        "storage_key": "property/6737460151192642/019e1ddc-80cf-76ad-b3be-846abc806ed4.webp",
        "width": 1280,
        "height": 579
      },
      "poi_business_url": "https://www.tractorsupply.com/tsc/store_Aransaspass-TX-78336_1169",
      "poi_directions_map_url": "https://maps.google.com/?cid=6656565973729377362&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tractor-supply-co",
      "poi_latitude": "27.9184792",
      "poi_longitude": "-97.164057",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 361-758-8761",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJBxFR6g1SaIYRUnwXMHzfYFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_5687f20d-5fcf-462a-8134-45c428f82f2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "Palm Plaza, 1921 W Wheeler Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_long_description": "Discount chain carrying a variety of goods, including groceries, household items & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-7e7e-7159-8746-c0221179f4ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-7e7e-7159-8746-c0221179f4ad",
        "storage_key": "property/6737460151192642/019e1ddc-7e7e-7159-8746-c0221179f4ad.webp",
        "width": 864,
        "height": 864
      },
      "poi_business_url": "https://locations.familydollar.com/tx/aransas-pass/1921-w-wheeler-ave?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=17120114840544877645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "27.9165932",
      "poi_longitude": "-97.1652348",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 361-529-7464",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJSQVR6g1SaIYRTRySwL3dlu0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_7ec30cc8-d437-4579-bab6-5729c958d198",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "2650 Demory Ln Suite E, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-7dda-71eb-83b4-b2e8d127b8bf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-7dda-71eb-83b4-b2e8d127b8bf",
        "storage_key": "property/6737460151192642/019e1ddc-7dda-71eb-83b4-b2e8d127b8bf.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/tx/aransas-pass/2650-demory-lane-suite-e?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11409531964837624553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "27.9219879",
      "poi_longitude": "-97.1783383",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 361-717-1649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyXr00QFSaIYR6XqcKd_MVp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_c788829c-5ba8-425c-a0c1-01124fb6498f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "O'Reilly Auto Parts",
      "poi_type": "Shopping & Retail",
      "poi_address": "607 S Commercial St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Chain retailer offering auto parts, tools, and accessories, plus services like battery testing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-7e3b-70c1-a448-62816f4a9a46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-7e3b-70c1-a448-62816f4a9a46",
        "storage_key": "property/6737460151192642/019e1ddc-7e3b-70c1-a448-62816f4a9a46.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.oreillyauto.com/en-us/tx/aransaspass/autoparts-690.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=2895171196888638474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oreilly-auto-parts",
      "poi_latitude": "27.8995367",
      "poi_longitude": "-97.1473908",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-758-8598",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJww49I0NSaIYRCmR9Qt22LSg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auto_parts_store"
    },
    {
      "id": "custom_7c42e0ff-7361-452c-a86c-3d88bf27d0b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Aaron's Rent To Own",
      "poi_type": "Shopping & Retail",
      "poi_address": "2502 W Wheeler Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Retailer for lease-to-own electronics, furniture and appliances as well as rental options for the same.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-7ec5-777b-9e86-4b150c248c50.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-7ec5-777b-9e86-4b150c248c50",
        "storage_key": "property/6737460151192642/019e1ddc-7ec5-777b-9e86-4b150c248c50.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.aarons.com/locations/us/tx/aransas-pass/2502-w-wheeler-ave?y_source=1_MTUzNTI1OTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=4398380196259636271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aarons-rent-to-own",
      "poi_latitude": "27.9240281",
      "poi_longitude": "-97.174581",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-758-2310",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJUxfAswBSaIYRLyQrIXwvCj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_1cac2e5b-45e4-4e2f-bd94-b7f2d8979c64",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Stetson's Army /Navy Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "462 S Commercial St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Family-owned vendor featuring military, work and biker clothing, boots and leather jackets.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-041f-75ed-b1bb-c4ef5a71ca55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-041f-75ed-b1bb-c4ef5a71ca55",
        "storage_key": "property/6737460151192642/019e1dda-041f-75ed-b1bb-c4ef5a71ca55.webp",
        "width": 1280,
        "height": 819
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13981553449048426198&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stetsons-army-navy-store",
      "poi_latitude": "27.901645",
      "poi_longitude": "-97.147181",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-758-5424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJI8G1zUJSaIYR1kar0sh0CMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_ef56ba1d-f668-41cf-a11d-bc049d6120f0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Charlie Marshall Elementary School",
      "poi_type": "Education",
      "poi_address": "2300 McMullen Ln, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.apisd.org",
      "poi_directions_map_url": "https://maps.google.com/?cid=4449361879997313840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "charlie-marshall-elementary-school",
      "poi_latitude": "27.9148198",
      "poi_longitude": "-97.1734449",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 361-758-3455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-90565d7ae288",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr5fvVQNSaIYRMHNnXg5Pvz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_79f296f7-6aa9-40d2-b874-12893a3b6e61",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "H.T. Faulk Early Childhood School",
      "poi_type": "Education",
      "poi_address": "430 S 8th St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://fec.apisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15948505841017047192&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ht-faulk-early-childhood-school",
      "poi_latitude": "27.9068818",
      "poi_longitude": "-97.1559978",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "27 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-758-3141",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-90565d7ae288",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJSYIsDmtSaIYRmEgQSJB5VN0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_44c45113-d609-4751-a9d0-19900762d4ca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Kieberger Elementary School",
      "poi_type": "Education",
      "poi_address": "748 W Goodnight Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4930811824814417411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kieberger-elementary-school",
      "poi_latitude": "27.9071647",
      "poi_longitude": "-97.153305",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-758-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-90565d7ae288",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi5XhtWtSaIYRA-Zb6DrDbUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_83c305fe-01b1-4cb3-a442-0c512f4422c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "A C Blunt Middle School",
      "poi_type": "Education",
      "poi_address": "2103 Demory Ln, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.apisd.org/o/acbms",
      "poi_directions_map_url": "https://maps.google.com/?cid=17563259696491176273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "a-c-blunt-middle-school",
      "poi_latitude": "27.9158382",
      "poi_longitude": "-97.170987",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 361-758-2711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-90565d7ae288",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJa7lp9g9SaIYRUaFKy6M7vfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_7b21685b-cb49-4345-8d69-891c95c8fc1c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Aransas Pass High School",
      "poi_type": "Education",
      "poi_address": "450 S Ave A, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-7f91-70bf-bc5b-5acccdcd5efb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-7f91-70bf-bc5b-5acccdcd5efb",
        "storage_key": "property/6737460151192642/019e1ddc-7f91-70bf-bc5b-5acccdcd5efb.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "http://aphs.apisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1504448423996145212&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-pass-high-school",
      "poi_latitude": "27.9131514",
      "poi_longitude": "-97.167866",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 361-758-3248",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-90565d7ae288",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJQWsLNxBSaIYRPL4v597f4BQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_8a2f1012-c348-4612-8077-70a51cab9a3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Lighthouse Learning Center & Day",
      "poi_type": "Education",
      "poi_address": "517 S Ave A, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3489441890309463195&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lighthouse-learning-center--day",
      "poi_latitude": "27.9113123",
      "poi_longitude": "-97.1667704",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 361-758-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-90565d7ae288",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGbOyjBBSaIYRm1xDUOn8bDA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_75854f5b-6cae-4858-9840-ba0100f2a0b3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Aransas Pass Aquatic Center",
      "poi_type": "Entertainment",
      "poi_address": "400 E Johnson Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Public pool with a variety of slides, a diving board, and other attractions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-8360-746a-b7ba-b90c97a99741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-8360-746a-b7ba-b90c97a99741",
        "storage_key": "property/6737460151192642/019e1ddc-8360-746a-b7ba-b90c97a99741.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://aransaspasstx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12744708679171408705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-pass-aquatic-center",
      "poi_latitude": "27.884539",
      "poi_longitude": "-97.1538969",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 361-758-7770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwkoj0lSaIYRQYPZ8wRN3rA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "swimming_pool"
    },
    {
      "id": "custom_7535a9df-3701-4a67-89da-bc66f03a113a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Lydia Ann Lighthouse",
      "poi_type": "Entertainment",
      "poi_address": "Harbor Island Road, Port Aransas, TX 78373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-8345-72c0-a39e-8263e939ec78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-8345-72c0-a39e-8263e939ec78",
        "storage_key": "property/6737460151192642/019e1ddc-8345-72c0-a39e-8263e939ec78.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lighthousefriends.com/light.asp?ID=158",
      "poi_directions_map_url": "https://maps.google.com/?cid=1406934632970160146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lydia-ann-lighthouse",
      "poi_latitude": "27.8641689",
      "poi_longitude": "-97.0564174",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX6LOEvOsaYYREohhLJhvhhM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_468787e8-1deb-494d-a735-ce44243d4df8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Port Aransas Museum",
      "poi_type": "Entertainment",
      "poi_address": "408 N Alister St, Port Aransas, TX 78373, USA",
      "poi_short_description": "A kit house from the early 1900s is home to this center for regional history & preservation.",
      "poi_long_description": "A kit house from the early 1900s is home to this center for regional history & preservation.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-82f7-749a-9d0f-b927d0455f06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-82f7-749a-9d0f-b927d0455f06",
        "storage_key": "property/6737460151192642/019e1ddc-82f7-749a-9d0f-b927d0455f06.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://portaransasmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17201784021869667292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-aransas-museum",
      "poi_latitude": "27.8356945",
      "poi_longitude": "-97.060894",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 361-749-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddd-16b3-756e-ad18-c12138bf12cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-16b3-756e-ad18-c12138bf12cf",
        "storage_key": "property/6737460151192642/019e1ddd-16b3-756e-ad18-c12138bf12cf.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJc-_R2WKraYYR3COIzm0Due4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_6e321378-1a2c-46ce-a728-9e2ef993c581",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Roberts Point Park",
      "poi_type": "Entertainment",
      "poi_address": "301 J C Barr Blvd, Port Aransas, TX 78373, USA",
      "poi_short_description": "This 50-acre waterfront park features a music venue, a pavilion, an observation tower & more.",
      "poi_long_description": "This 50-acre waterfront park features a music venue, a pavilion, an observation tower & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-881b-74ce-b95e-014872711b35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-881b-74ce-b95e-014872711b35",
        "storage_key": "property/6737460151192642/019e1ddc-881b-74ce-b95e-014872711b35.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cityofportaransas.org/departments/parks-and-recreation/roberts-point-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1601364258613341449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roberts-point-park",
      "poi_latitude": "27.8405158",
      "poi_longitude": "-97.0654963",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 361-749-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffec-7108-b7b9-62318010134e",
        "storage_key": "property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4D_0J2saYYRCa2nDk8wORY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_277c2d91-6f6f-442e-9929-5bfe02e1941f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "The Palm Social Club",
      "poi_type": "Entertainment",
      "poi_address": "801 Tarpon St, Port Aransas, TX 78373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-8945-71ea-87a1-dfcd7e5fcdf2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-8945-71ea-87a1-dfcd7e5fcdf2",
        "storage_key": "property/6737460151192642/019e1ddc-8945-71ea-87a1-dfcd7e5fcdf2.webp",
        "width": 1280,
        "height": 958
      },
      "poi_business_url": "https://www.thepalmsocialclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=369810288061180451&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-palm-social-club",
      "poi_latitude": "27.8389466",
      "poi_longitude": "-97.0599111",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 361-339-1822",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff22-7238-9518-45cd02291c2f",
        "storage_key": "property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ16-g-jitaYYRI-orZn_UIQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_3e3a06af-229a-40e7-a26a-6be3aef2c067",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Shorty's Place",
      "poi_type": "Entertainment",
      "poi_address": "101 Beach St, Port Aransas, TX 78373, USA",
      "poi_short_description": "Laid-back watering hole featuring the cold beers, dive-bar vibes and old-school feel.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-888d-70ba-9438-73df8d4d94cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-888d-70ba-9438-73df8d4d94cf",
        "storage_key": "property/6737460151192642/019e1ddc-888d-70ba-9438-73df8d4d94cf.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://shortysportaransas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16723466596478901796&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "shortys-place",
      "poi_latitude": "27.83421",
      "poi_longitude": "-97.0612669",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 361-749-8224",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff22-7238-9518-45cd02291c2f",
        "storage_key": "property/6737460151192642/019e1dda-ff22-7238-9518-45cd02291c2f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7S-JuoKsaYYRJF48yEOwFeg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_4eb130aa-65b7-45de-bfbc-4a02ea1acfbf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Woodys Last Stand/ Dolphin Watch Nature Tours",
      "poi_type": "Entertainment",
      "poi_address": "154 W Cotter Ave, Port Aransas, TX 78373, USA",
      "poi_short_description": "Educational boat tour operator for dolphin-watching trips along the coast, with touch tanks for sea creatures.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-8e5d-738a-93f8-7c35554050af.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-8e5d-738a-93f8-7c35554050af",
        "storage_key": "property/6737460151192642/019e1ddc-8e5d-738a-93f8-7c35554050af.webp",
        "width": 1280,
        "height": 773
      },
      "poi_business_url": "http://www.woodyslaststand.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16291660324363766968&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodys-last-stand-dolphin-watch-nature-tours",
      "poi_latitude": "27.8387565",
      "poi_longitude": "-97.0625982",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "39 mins",
      "poi_business_phone": "+1 361-749-6969",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb2NXZ52saYYRuAwHg7-aF-I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tour_agency"
    },
    {
      "id": "custom_1523311d-842b-45c9-b44e-6981f97c4baf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Care Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1711 W Wheeler Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.crmctx.com",
      "poi_directions_map_url": "https://maps.google.com/?cid=360716723094550745&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "care-regional-medical-center",
      "poi_latitude": "27.9151701",
      "poi_longitude": "-97.1624689",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 361-758-8585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddd-16fc-7658-9733-ebda8ae0ebab.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-16fc-7658-9733-ebda8ae0ebab",
        "storage_key": "property/6737460151192642/019e1ddd-16fc-7658-9733-ebda8ae0ebab.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJHTIa4Q1SaIYR2fiX0PKFAQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_fe6cee17-260e-43c4-b46c-4b0c3ee954f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "ER 24/7 Portland, a department of Corpus Christi Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1702 US-181 N Suite A-11, Portland, TX 78374, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-8f6a-70df-9ace-bd05c128986d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-8f6a-70df-9ace-bd05c128986d",
        "storage_key": "property/6737460151192642/019e1ddc-8f6a-70df-9ace-bd05c128986d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ccmedicalcenter.com/locations/er-24-7-portland?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13474517771034024364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "er-247-portland-a-department-of-corpus-christi-medical-center",
      "poi_latitude": "27.8883836",
      "poi_longitude": "-97.3111781",
      "poi_miles_from_property": "12.1",
      "poi_walking_minutes": "4 hours 23 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 361-761-2273",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgRCwtBpbaIYRrNkrjoUa_7o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_b17f8c57-0e94-472d-bd41-f48752dd2305",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Duwayne P Edge Do",
      "poi_type": "Health and Wellness",
      "poi_address": "2605 Amarillo St, Ingleside, TX 78362, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7066757467733935262&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "duwayne-p-edge-do",
      "poi_latitude": "27.8779474",
      "poi_longitude": "-97.2123123",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 361-775-0961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWYueE6hRaIYRnsQewnkqEmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_f905b898-84bf-4041-b896-941e1ce1cd58",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "StatCare Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2102 FM2165, Rockport, TX 78382, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-94a2-741f-878a-223b6eaeacee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-94a2-741f-878a-223b6eaeacee",
        "storage_key": "property/6737460151192642/019e1ddc-94a2-741f-878a-223b6eaeacee.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.mystatcare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17597162951259349281&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "statcare-urgent-care",
      "poi_latitude": "28.0515831",
      "poi_longitude": "-97.0669169",
      "poi_miles_from_property": "12.3",
      "poi_walking_minutes": "4 hours 28 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 361-556-5770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQeLxIMu1aYYRIWF6bHiuNfQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_2e9e4452-8915-4762-b95f-f609d4e47022",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2702 W Wheeler Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-9494-7580-a522-5fe73dcfa56d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-9494-7580-a522-5fe73dcfa56d",
        "storage_key": "property/6737460151192642/019e1ddc-9494-7580-a522-5fe73dcfa56d.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-2702+w+wheeler+ave-aransas+pass-tx-78336/id=10680",
      "poi_directions_map_url": "https://maps.google.com/?cid=3983674217275333412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "27.9255842",
      "poi_longitude": "-97.1769179",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 361-758-2135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddd-1755-7532-b14f-75248688290e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-1755-7532-b14f-75248688290e",
        "storage_key": "property/6737460151192642/019e1ddd-1755-7532-b14f-75248688290e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Yo2hv9NaIYRJBuUHZjaSDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_8bd5b763-6655-4a1a-9e64-f14c42435b92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "H-E-B Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "101 E Goodnight Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-944c-74cd-9e54-e7ad50609bc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-944c-74cd-9e54-e7ad50609bc8",
        "storage_key": "property/6737460151192642/019e1ddc-944c-74cd-9e54-e7ad50609bc8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/pharmacy/common/landing?utm_source=google&utm_medium=organic&utm_campaign=gmb_pharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=6205345332735803113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-pharmacy",
      "poi_latitude": "27.901362",
      "poi_longitude": "-97.146154",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-758-9565",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddd-1755-7532-b14f-75248688290e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-1755-7532-b14f-75248688290e",
        "storage_key": "property/6737460151192642/019e1ddd-1755-7532-b14f-75248688290e.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKTWdOF1SaIYR6X5Y6rPQHVY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_e15cd3f9-861d-4fe6-8b08-8d8577cfa28f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Texas Strong Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "350 S Houston St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Gym offering an array of weight machines and free weights, plus clean up-to-date equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-28b3-747f-82b1-87f2bf8557ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-28b3-747f-82b1-87f2bf8557ed",
        "storage_key": "property/6737460151192642/019e1dda-28b3-747f-82b1-87f2bf8557ed.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.texasstrongfitness.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=143496610268652492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-strong-fitness",
      "poi_latitude": "27.9034981",
      "poi_longitude": "-97.1473339",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-230-4635",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQ-BqWlTaIYRzCOJIWjN_QE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9e704786-4f18-487f-9a48-599068bf3d0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "FITsique Training 1",
      "poi_type": "Health and Wellness",
      "poi_address": "301 S Commercial St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-988f-7779-9601-b1fd63186077.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-988f-7779-9601-b1fd63186077",
        "storage_key": "property/6737460151192642/019e1ddc-988f-7779-9601-b1fd63186077.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://fitsiquetraining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2850429064492808771&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitsique-training-1",
      "poi_latitude": "27.9032826",
      "poi_longitude": "-97.1451716",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-960-0148",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUS9ivZdTaIYRQ_qKxiHCjic",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c083b9d6-9a25-452e-9d9f-9ee2d18931bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Snap Fitness Ingleside",
      "poi_type": "Health and Wellness",
      "poi_address": "2334 TX-361 Suites 138-158, Ingleside, TX 78362, USA",
      "poi_short_description": "Chain fitness center providing 24/7 access to cardio and strength-training equipment.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-139e-7630-a503-b7d1ed91c14e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-139e-7630-a503-b7d1ed91c14e",
        "storage_key": "property/6737460151192642/019e1dda-139e-7630-a503-b7d1ed91c14e.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.snapfitness.com/us/gyms/ingleside-tx/?utm_source=gmb&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=859828588672439084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snap-fitness-ingleside",
      "poi_latitude": "27.8797499",
      "poi_longitude": "-97.2031516",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 361-345-4543",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFaQA-KBRaIYRLNOLu4u57gs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7a48ea3a-6e61-4987-9487-82c069954c1f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "The Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "337 N Alister St, Port Aransas, TX 78373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-9a07-702f-b4ab-4dd846efc1cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-9a07-702f-b4ab-4dd846efc1cc",
        "storage_key": "property/6737460151192642/019e1ddc-9a07-702f-b4ab-4dd846efc1cc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://thestudioporta.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1954109052650447853&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-studio",
      "poi_latitude": "27.8350771",
      "poi_longitude": "-97.061946",
      "poi_miles_from_property": "9.4",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 361-717-1272",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-90565d7ae288",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ0wq3P_uraYYR7eOaf9RjHhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_1c4e0481-3951-4f9c-916a-f033d62073f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Port Aransas Nature Preserve at Charlie's Pasture",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Port Aransas, TX 78373, USA",
      "poi_short_description": "Pristine park with winding trails, marshes, and abundant birdlife, plus sunset and dolphin viewing.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-986b-7229-a893-c5a8f351b0e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-986b-7229-a893-c5a8f351b0e2",
        "storage_key": "property/6737460151192642/019e1ddc-986b-7229-a893-c5a8f351b0e2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cityofportaransas.org/departments/parks-and-recreation/nature-preserve/charlies-pasture/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13568625611891543240&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-aransas-nature-preserve-at-charlies-pasture",
      "poi_latitude": "27.8341003",
      "poi_longitude": "-97.0863007",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "42 mins",
      "poi_business_phone": "+1 361-749-0081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffec-7108-b7b9-62318010134e",
        "storage_key": "property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJY0aTX4uraYYRyAwQtxpxTbw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_af275a3f-3207-43ac-8cab-b027f8e7aa06",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Leonabelle Turnbull Birding Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1356 Ross Ave, Port Aransas, TX 78373, USA",
      "poi_short_description": "Observation area for birds, alligators & fish, featuring a boardwalk & tower with panoramic views.",
      "poi_long_description": "Observation area for birds, alligators & fish, featuring a boardwalk & tower with panoramic views.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-96f9-76be-a2d5-b869390f3961.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-96f9-76be-a2d5-b869390f3961",
        "storage_key": "property/6737460151192642/019e1ddc-96f9-76be-a2d5-b869390f3961.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cityofportaransas.org/departments/parks-and-recreation/nature-preserve/birding-center/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17808724800613476167&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "leonabelle-turnbull-birding-center",
      "poi_latitude": "27.8272791",
      "poi_longitude": "-97.0783761",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "+1 361-749-4158",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4JxhFqraYYRR2dB-9lMJfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_49dc6976-9e41-4eb9-b62d-b17baee00fb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Wetland Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Wetland Park, 1112 TX-361, Port Aransas, TX 78373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-9b2b-749d-8b15-ea5dd2dc9608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-9b2b-749d-8b15-ea5dd2dc9608",
        "storage_key": "property/6737460151192642/019e1ddc-9b2b-749d-8b15-ea5dd2dc9608.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cityofportaransas.org/departments/parks-and-recreation/nature-preserve/wetland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8582549393137427712&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wetland-park",
      "poi_latitude": "27.8245836",
      "poi_longitude": "-97.0704223",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "+1 361-749-4111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffec-7108-b7b9-62318010134e",
        "storage_key": "property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3573FWiraYYRAGUzZTNXG3c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bbc0740c-e856-4300-921c-f130aac419d5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Lighthouse Lakes Trails Park - Kayak Launch",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1 Haines Wy, Port Aransas, TX 78373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-9d3e-7673-980f-1c7ab07b4935.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-9d3e-7673-980f-1c7ab07b4935",
        "storage_key": "property/6737460151192642/019e1ddc-9d3e-7673-980f-1c7ab07b4935.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18248010864653430797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lighthouse-lakes-trails-park---kayak-launch",
      "poi_latitude": "27.8669627",
      "poi_longitude": "-97.0844427",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuefw5c6saYYRDfAiBTP1Pf0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0ea00ac5-ad6d-42a1-8f75-6682d52fbe69",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "UTMSI Wetlands Education Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "855 E Cotter Ave, Port Aransas, TX 78373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-9dff-7582-94b4-c54eaa41b61b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-9dff-7582-94b4-c54eaa41b61b",
        "storage_key": "property/6737460151192642/019e1ddc-9dff-7582-94b4-c54eaa41b61b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18137860825741297753&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "utmsi-wetlands-education-center",
      "poi_latitude": "27.8365783",
      "poi_longitude": "-97.0510232",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "41 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffec-7108-b7b9-62318010134e",
        "storage_key": "property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJcTgQYPWraYYRWYjIj1Kgtvs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e903ce34-0603-43c3-a663-a6df99524a73",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Conn Brown HarborPoint Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Bigelow St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Many commercial & tourist fishing boats use this harbor as a departure point for day trips.",
      "poi_long_description": "Many commercial & tourist fishing boats use this harbor as a departure point for day trips.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-33a4-7259-a1a8-47d6c8f6cd27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-33a4-7259-a1a8-47d6c8f6cd27",
        "storage_key": "property/6737460151192642/019e1dda-33a4-7259-a1a8-47d6c8f6cd27.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=73974050773381377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conn-brown-harborpoint-park",
      "poi_latitude": "27.8997372",
      "poi_longitude": "-97.1361753",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffec-7108-b7b9-62318010134e",
        "storage_key": "property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJTae2ivVSaIYRAbHx2gHPBgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c275d868-a993-4c90-9ea5-02a8f31142fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Rockport Beach Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "319 Broadway St, Rockport, TX 78382, USA",
      "poi_short_description": "Family-friendly spot with calm waters, a playground, pavilion & more.",
      "poi_long_description": "Family-friendly spot with calm waters, a playground, pavilion & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-a456-70bf-8569-a517109c5a3d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-a456-70bf-8569-a517109c5a3d",
        "storage_key": "property/6737460151192642/019e1ddc-a456-70bf-8569-a517109c5a3d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.rockportbeach-texas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15007700107399948428&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rockport-beach-park",
      "poi_latitude": "28.0309567",
      "poi_longitude": "-97.0377305",
      "poi_miles_from_property": "13.1",
      "poi_walking_minutes": "4 hours 46 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 361-729-6661",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffec-7108-b7b9-62318010134e",
        "storage_key": "property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGdvkXXe0aYYRjGgqxbsPRtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_87d6a0ff-3cae-4610-a791-1f9eed471e8a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Goose Island State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "202 S Palmetto St, Rockport, TX 78382, USA",
      "poi_short_description": "Abundant recreational activities on 320 acres of marsh & prairie, with a tree dating 1,000+ years.",
      "poi_long_description": "Abundant recreational activities on 320 acres of marsh & prairie, with a tree dating 1,000+ years.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-a4ed-7399-aa53-8bc4b42b0dd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-a4ed-7399-aa53-8bc4b42b0dd0",
        "storage_key": "property/6737460151192642/019e1ddc-a4ed-7399-aa53-8bc4b42b0dd0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/goose-island",
      "poi_directions_map_url": "https://maps.google.com/?cid=5645286817377101663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goose-island-state-park",
      "poi_latitude": "28.1341516",
      "poi_longitude": "-96.9842456",
      "poi_miles_from_property": "21.6",
      "poi_walking_minutes": "7 hours 50 mins",
      "poi_biking_minutes": "1 hour 54 mins",
      "poi_driving_minutes": "28 mins",
      "poi_business_phone": "+1 361-729-2858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffec-7108-b7b9-62318010134e",
        "storage_key": "property/6737460151192642/019e1dda-ffec-7108-b7b9-62318010134e.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJrY6I38HJaYYRXyf1THMWWE4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_86f730ef-474e-4a22-8531-4b55a098eb22",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Ingleside Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "3141 FM3512, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-3584-764a-a018-44300efbc9df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1dda-3584-764a-a018-44300efbc9df",
        "storage_key": "property/6737460151192642/019e1dda-3584-764a-a018-44300efbc9df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.sanpat.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4869847340896355185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingleside-regional-airport",
      "poi_latitude": "27.9147052",
      "poi_longitude": "-97.2081756",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 361-758-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffe3-765c-a35c-4b57c636f728.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffe3-765c-a35c-4b57c636f728",
        "storage_key": "property/6737460151192642/019e1dda-ffe3-765c-a35c-4b57c636f728.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJi60Ags1RaIYRcQOC4FoslUM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_4555e6fa-9613-4b91-97ba-cf95c5749928",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Port Aransas Ferry Landing",
      "poi_type": "Transportation & Transit",
      "poi_address": "619 W Cotter Ave, Port Aransas, TX 78373, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-a48a-70b4-b7fc-52ff182d5e7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-a48a-70b4-b7fc-52ff182d5e7c",
        "storage_key": "property/6737460151192642/019e1ddc-a48a-70b4-b7fc-52ff182d5e7c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.portaransas.org/plan/transportation/ferry/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17519353593087414393&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-aransas-ferry-landing",
      "poi_latitude": "27.8396272",
      "poi_longitude": "-97.0690363",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "36 mins",
      "poi_business_phone": "+1 361-749-5494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddd-175e-73bc-a430-530bda0db2fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-175e-73bc-a430-530bda0db2fc",
        "storage_key": "property/6737460151192642/019e1ddd-175e-73bc-a430-530bda0db2fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa0RQ2n2raYYReVBwekU_IfM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_3a1bc229-0a6b-4721-92d9-fccdc32ad26a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Greyhound: Bus Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "235 W Cleveland Blvd, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-a885-7249-af00-9edf791a826f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-a885-7249-af00-9edf791a826f",
        "storage_key": "property/6737460151192642/019e1ddc-a885-7249-af00-9edf791a826f.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.greyhound.com/bus/aransas-pass-tx/aransas-pass-stripes?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=17926170966325541854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-stop",
      "poi_latitude": "27.9107279",
      "poi_longitude": "-97.1430263",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJCx78O2RSaIYR3jvBVoSNxvg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_7cf4bd44-3507-4e85-b37d-b9c99c132c2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Redfish Bay Boat House",
      "poi_type": "Transportation & Transit",
      "poi_address": "322 Huff St, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-b1e9-7434-822b-08a7cb707a32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-b1e9-7434-822b-08a7cb707a32",
        "storage_key": "property/6737460151192642/019e1ddc-b1e9-7434-822b-08a7cb707a32.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.redfishbayboathouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10300006015749842611&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "redfish-bay-boat-house",
      "poi_latitude": "27.9110668",
      "poi_longitude": "-97.1342444",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 361-758-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ffd6-7045-8d36-a1cd1a670af4",
        "storage_key": "property/6737460151192642/019e1dda-ffd6-7045-8d36-a1cd1a670af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWaHNlIlSaIYRs-YnSeb48I4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "marina"
    },
    {
      "id": "custom_ee345a71-99c0-4e10-8114-b48990c05151",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "South Bay Marina Fishing Charters",
      "poi_type": "Transportation & Transit",
      "poi_address": "TX-361, Aransas Pass, TX 78335, USA",
      "poi_short_description": "Outfitters of live and frozen bait, plus boat rentals and charters.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-aa6b-77c9-8f85-56adb52b5261.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-aa6b-77c9-8f85-56adb52b5261",
        "storage_key": "property/6737460151192642/019e1ddc-aa6b-77c9-8f85-56adb52b5261.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://bayratboats.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16546829784901393836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-bay-marina-fishing-charters",
      "poi_latitude": "27.8813152",
      "poi_longitude": "-97.0998346",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 361-758-6900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi4DL5pJTaIYRrJ3mPwUmouU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_21afbe18-753a-4b60-8b35-e2f16da3f8f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Fin and Feather Bait",
      "poi_type": "Transportation & Transit",
      "poi_address": "1803 TX-361, Aransas Pass, TX 78336, USA",
      "poi_short_description": "Bait shop offering live and custom-braided line, plus some fishing advice.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-c31c-7435-adcb-3efe8a77f7d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-c31c-7435-adcb-3efe8a77f7d7",
        "storage_key": "property/6737460151192642/019e1ddc-c31c-7435-adcb-3efe8a77f7d7.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4349079713723016706&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fin-and-feather-bait",
      "poi_latitude": "27.8883781",
      "poi_longitude": "-97.1122472",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 361-758-7414",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-8fac56e9e6a5",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-8fac56e9e6a5.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVVVVVdxSaIYRAmZRDPUIWzw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_713c3839-cd56-47c7-a8d8-99907a4a0778",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Aransas Pass School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "748 W Goodnight Ave, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.apisd.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8017696435072341474&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-pass-school-district",
      "poi_latitude": "27.9070738",
      "poi_longitude": "-97.1533069",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-758-4200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1dda-ff66-74ca-8605-90565d7ae288",
        "storage_key": "property/6737460151192642/019e1dda-ff66-74ca-8605-90565d7ae288.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJ-Yzl0JSaIYR4hVnmW2URG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_683cc32a-c00a-461a-b150-9cfdf4018673",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "poi_name": "Aransas Pass City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "600 W Cleveland Blvd, Aransas Pass, TX 78336, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddc-bb97-761a-93c3-8f90160c0b0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1ddc-bb97-761a-93c3-8f90160c0b0b",
        "storage_key": "property/6737460151192642/019e1ddc-bb97-761a-93c3-8f90160c0b0b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.aransaspasstx.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2561838232275775222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aransas-pass-city-hall",
      "poi_latitude": "27.910225",
      "poi_longitude": "-97.1494905",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 361-758-5301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e1ddd-175e-73bc-a430-530bda0db2fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1ddd-175e-73bc-a430-530bda0db2fc",
        "storage_key": "property/6737460151192642/019e1ddd-175e-73bc-a430-530bda0db2fc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVyz0Wm9SaIYR9u7Pjkx6jSM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_7ecab800-70a6-4308-8a33-b09f1326c143",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e19b7ab3-833c-40f2-934e-cb3cbd92290a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5b68b21a-1333-4c76-acbd-9d6479ff9749",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b44125da-1be1-424b-8798-9ab7d00a81d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_188d0e72-1e21-4634-8333-fae4a4fda400",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_67ec40e6-d570-4ab2-9428-f9040d95fb3a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "rating": "5",
      "name": "Dev Garza",
      "text": "Quit and great community for kids. Ryanne has been very informative and is eager to answer questions to the best of her ability. Looking forward to the amenities getting updated.",
      "date": "2026-04-24",
      "title": "false"
    },
    {
      "id": "custom_6ee93460-1504-405c-b898-5d86729525f8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "rating": "5",
      "name": "Fela Alvarado",
      "text": "Thank you Rosanna for the prompt service. I appreciate you.",
      "date": "2026-04-29",
      "title": "false"
    },
    {
      "id": "custom_bd81d648-b109-4436-ba43-63e628a423fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "rating": "5",
      "name": "kati criddle",
      "text": "I can’t say enough good things about Ryanne Maiden! From the moment we walked in, she took the time to show us around and made everything feel easy and stress-free. She sent over the application quickly and we were approved the very next day. She’s such a wonderful, genuine person and made this whole experience so much better. And I have to say red is her color! ❤️",
      "date": "2026-04-17",
      "title": "false"
    },
    {
      "id": "custom_0ce813e9-a049-4ec2-9cc2-f7f8018073fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "rating": "5",
      "name": "paula singleton",
      "text": "Maintenance guys are great. Very friendly and know what they are doing. Great job guys.",
      "date": "2026-02-13",
      "title": "false"
    },
    {
      "id": "custom_d5c3dcf9-f2fe-421d-b0af-b47a2bfbd392",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "rating": "5",
      "name": "Kathy Blue",
      "text": "Very pleased with our new maintenance department. Nice job!!",
      "date": "2026-01-16",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_693cf2af-00ea-441e-a93a-8166a85b0950",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019e678c-3f49-726f-a456-af750a21d321.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e678c-3f49-726f-a456-af750a21d321",
        "storage_key": "property/6737460151192642/019e678c-3f49-726f-a456-af750a21d321.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Clubroom",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=68427a87af6f144c266c03a1"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01996487-133d-764e-9f46-3b7b9e812643",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-windy-shores-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642"
    },
    {
      "lead_collector_id": "0199def4-a7d9-70da-b925-fb40cdf883d8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-windy-shores-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-aransas-pass",
      "search_query": "dog-friendly apartments Aransas Pass",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in Aransas Pass",
      "h2_subtitle": "Explore dog-friendly apartments at Windy Shores. Located in Aransas Pass, enjoy amenities tailored for pets and their owners.",
      "page_copy": "Discover a welcoming community at Windy Shores, where dog-friendly apartments in Aransas Pass await you and your furry friends. We offer spacious two, three, or four-bedroom layouts that provide plenty of room for you and your pet to roam. Our convenient location in Downtown Ingleside, near beautiful parks and walking trails, makes it easy to enjoy the outdoors together.\n\nAt Windy Shores, we understand that pets are family. That's why we are proud to feature a delightful dog park where your canine companion can run and play. In addition to being a smoke-free community, our top-notch amenities include a refreshing pool and modern fitness center, giving you the perfect backdrop for a balanced lifestyle. Schedule a tour today and see why our pet-friendly environment is perfect for you and your pup!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d0784-89d9-77ad-bc23-ca7fe7d94f3b",
        "storage_key": "property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments in Aransas Pass",
      "seo_description": "Find dog-friendly apartments in Aransas Pass at Windy Shores. Enjoy a pet-friendly community with a dog park and spacious living areas.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "generator",
      "page_item_url": "apartments-with-pool-san-patricio-county",
      "search_query": "apartments with pool San Patricio County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in San Patricio County",
      "h2_subtitle": "Windy Shores offers apartments with a pool right in San Patricio County. Enjoy modern amenities in a welcoming community.",
      "page_copy": "Welcome to Windy Shores, the ideal choice for those seeking apartments with a pool in San Patricio County. Our spacious two, three, and four-bedroom options are designed with comfort and convenience in mind. Located in the heart of Downtown Ingleside, you're just a short drive from the best attractions in Aransas Pass and beyond.\n\nRelax and unwind by our beautifully maintained pool, the centerpiece of our community amenities. Beyond the sparkling waters, residents can stay active in the modern fitness center or socialize in the inviting clubhouse. We are committed to creating a serene living environment, offering smoke-free surroundings and a welcoming atmosphere. Join us at Windy Shores and experience apartment living that truly has it all, right in the heart of San Patricio County.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d0784-89d9-77ad-bc23-ca7fe7d94f3b",
        "storage_key": "property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in San Patricio County",
      "seo_description": "Discover Windy Shores: Apartments with a pool in San Patricio County. Enjoy top amenities like a fitness center and lavish pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-78336",
      "search_query": "fitness center apartments 78336",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in 78336",
      "h2_subtitle": "Looking for fitness center apartments in 78336? Windy Shores offers top amenities and spacious living in Aransas Pass, TX.",
      "page_copy": "At Windy Shores, we cater to a healthy and active lifestyle with our fitness center apartments in the 78336 area. Whether you choose a two, three, or four-bedroom floor plan, our community in Aransas Pass, TX, ensures that staying fit is convenient and enjoyable. Nestled in Downtown Ingleside, our residents have easy access to everything they need.\n\nEnjoy modern amenities, including our state-of-the-art fitness center, where you can stay on top of your workout routine. Besides fitness, our smoke-free community offers a refreshing pool and a lively clubhouse, perfect for relaxing and socializing. Plus, with the convenience of in-unit washer/dryer and air conditioning, living in our well-appointed apartments is a breeze. Experience the perfect blend of comfort and convenience at Windy Shores today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d0784-89d9-77ad-bc23-ca7fe7d94f3b",
        "storage_key": "property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in 78336",
      "seo_description": "Explore fitness center apartments in 78336 at Windy Shores. Enjoy top amenities like a gym, pool, and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-ingleside",
      "search_query": "in unit laundry apartments Ingleside",
      "category": "Amenity",
      "h1_title": "In Unit Laundry Apartments Ingleside",
      "h2_subtitle": "Discover the convenience of in unit laundry apartments in Ingleside. Windy Shores offers modern amenities and comfortable living.",
      "page_copy": "Experience the ultimate in comfort and convenience with in unit laundry apartments at Windy Shores, located near Ingleside. Choose from our spacious two, three, or four-bedroom floor plans, designed with your lifestyle in mind. Situated in the vibrant community of Downtown Ingleside, our location offers easy access to the best of Aransas Pass, TX.\n\nAlong with the practicality of having your own washer and dryer, Windy Shores treats residents to a host of enjoyable amenities. Take a dip in the refreshing swimming pool or work out in our modern fitness center. The dog park provides a fun space for four-legged friends, while our smoke-free environment ensures a healthy living space. Visit Windy Shores today and see why our apartments are a perfect fit for those seeking convenience and quality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d0784-89d9-77ad-bc23-ca7fe7d94f3b",
        "storage_key": "property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In Unit Laundry Apartments in Ingleside",
      "seo_description": "Find in unit laundry apartments near Ingleside at Windy Shores. Enjoy spacious living with modern amenities and a vibrant community atmosphere.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-aransas-pass-tx",
      "search_query": "smoke free apartments Aransas Pass TX",
      "category": "Amenity",
      "h1_title": "Smoke Free Apartments Aransas Pass, TX",
      "h2_subtitle": "Looking for smoke free apartments in Aransas Pass, TX? Windy Shores offers a healthy, comfortable living environment with top amenities.",
      "page_copy": "Windy Shores is proud to offer smoke free apartments in the welcoming community of Aransas Pass, TX. Our commitment to a healthy living environment sets us apart, providing residents with a breath of fresh air in our beautifully designed two, three, and four-bedroom floor plans. Situated in Downtown Ingleside, you'll enjoy a tranquil setting with the convenience of nearby attractions.\n\nLiving at Windy Shores means access to a wide range of amenities, including a state-of-the-art fitness center, a relaxing pool, and a vibrant clubhouse for community gatherings. Each apartment comes equipped with in-unit washer/dryer and air conditioning for your comfort. The smoke-free policy extends throughout the community, ensuring a pleasant living experience for all residents. Discover the difference at Windy Shores today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d0784-89d9-77ad-bc23-ca7fe7d94f3b",
        "storage_key": "property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke Free Apartments in Aransas Pass, TX",
      "seo_description": "Explore smoke free apartments in Aransas Pass, TX at Windy Shores. Enjoy a healthy, comfortable living environment with modern amenities and spacious layouts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-aransas-pass",
      "search_query": "two bedroom apartments aransas pass",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Aransas Pass",
      "h2_subtitle": "Explore two bedroom apartments in Aransas Pass at Windy Shores. Discover comfort and style with top amenities designed for your lifestyle.",
      "page_copy": "Welcome to Windy Shores, where you can find spacious two bedroom apartments in Aransas Pass designed for comfort and convenience. Our well-appointed floor plans provide the perfect backdrop for your lifestyle, complemented by a range of contemporary amenities that truly enhance your living experience.\n\nNestled in the charming Downtown Ingleside neighborhood, Windy Shores offers easy access to local shops, dining, and entertainment. Enjoy our impressive community features, including a refreshing pool, a modern fitness center, and a vibrant clubhouse. Each apartment is equipped with in-unit washers and dryers, air conditioning, and a smoke-free environment for a healthier living experience. Discover the perfect two-bedroom apartment at Windy Shores and make it your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d0784-89d9-77ad-bc23-ca7fe7d94f3b",
        "storage_key": "property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Aransas Pass",
      "seo_description": "Discover two bedroom apartments in Aransas Pass at Windy Shores. Enjoy comfortable living with modern amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-downtown-ingleside",
      "search_query": "three bedroom apartments downtown ingleside",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Downtown Ingleside",
      "h2_subtitle": "Find spacious three bedroom apartments in downtown Ingleside at Windy Shores. Enjoy a vibrant community and modern amenities.",
      "page_copy": "Windy Shores offers exceptional three bedroom apartments in the heart of downtown Ingleside. Perfectly situated in a dynamic community, our residences are just what you need for convenient and comfortable living. With expansive floor plans, you'll have ample space to relax and entertain, all within a vibrant neighborhood setting.\n\nOur three-bedroom apartments come with top-notch amenities designed to enhance your lifestyle. Enjoy the luxury of having an in-unit washer and dryer, air conditioning, and access to a fully equipped fitness center. Whether you're unwinding by the pool or socializing in the clubhouse, Windy Shores offers a sense of community and tranquility. Make downtown Ingleside your home; explore our three-bedroom options today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d0784-89d9-77ad-bc23-ca7fe7d94f3b",
        "storage_key": "property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Downtown Ingleside",
      "seo_description": "Explore three bedroom apartments in downtown Ingleside at Windy Shores. Enjoy spacious layouts and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151192642",
      "source": "generator",
      "page_item_url": "four-bedroom-apartments-san-patricio-county",
      "search_query": "four bedroom apartments san patricio county",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments San Patricio County",
      "h2_subtitle": "Discover four bedroom apartments in San Patricio County at Windy Shores. Perfect for families or roommates, with ample amenities.",
      "page_copy": "Explore the spacious four bedroom apartments available at Windy Shores, nestled in the scenic San Patricio County. These expansive homes are ideally designed for growing families or those seeking additional space, offering a blend of comfort and modern living. Located in the welcoming community of Aransas Pass, you’ll enjoy the charm of coastal living combined with the convenience of contemporary amenities.\n\nEach four-bedroom apartment is thoughtfully designed to meet your lifestyle needs, featuring in-unit washers and dryers, air conditioning, and access to a smoke-free environment. As part of our community, residents have access to a refreshing swimming pool, a modern fitness center, and a fun-filled dog park, enhancing the overall living experience. Discover the perfect home for your family in San Patricio County with the four bedroom options at Windy Shores. Schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
      "featured_image_media": {
        "alt_text": "Kitchen with white cabinets, stainless steel appliances, and granite countertops.",
        "public_id": "019d0784-89d9-77ad-bc23-ca7fe7d94f3b",
        "storage_key": "property/6737460151192642/019d0784-89d9-77ad-bc23-ca7fe7d94f3b.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments in San Patricio County",
      "seo_description": "Find spacious four bedroom apartments in San Patricio County at Windy Shores. Ideal for families, with modern amenities and a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3420"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483371"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5005725"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TF2PL2PH"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "361-264-1250"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fbm_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=fbm"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "361-264-1585"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "361-264-1148"
    },
    {
      "ID": "custom_knock_rly_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=rly"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "361-264-1281"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "361-304-8427"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "361-264-1291"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "361-264-1572"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "361-264-1352"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "361-264-1013"
    },
    {
      "ID": "custom_knock_fbm_title",
      "type": "STRING",
      "value": "Facebook Marketplace"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "361-264-1445"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "361-273-1957"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_knock_rly_title",
      "type": "STRING",
      "value": "Rently"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "361-316-8846"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "361-266-4473"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_fbm_number",
      "type": "STRING",
      "value": "361-304-7716"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "361-282-5488"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "361-314-7748"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "361-264-3724"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "361-204-4642"
    },
    {
      "ID": "custom_knock_rly_number",
      "type": "STRING",
      "value": "361-309-0906"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "361-264-1438"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "361-301-2458"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321124211"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "361-266-3343"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "361-366-4894"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1ee8a62d24e16cd1"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "361-405-5295"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "361-264-1211"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "361-264-1587"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "361-314-9009"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "361-264-1242"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "361-264-1567"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://homes.rently.com/apartments-for-rent/windy%20shores/45091?source=community_link"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "361-264-1584"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.liveatwindyshores.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151192642/019e8495-342d-7448-9dad-66d7cab02a57.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "361-264-1439"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "361-273-1957"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3420",
  "custom_repli_id": "5028483371",
  "custom_realpage_id": "5005725",
  "custom_knock_a_link": "https://www.liveatwindyshores.com?utm_knock=a",
  "custom_knock_g_link": "https://www.liveatwindyshores.com?utm_knock=g",
  "custom_knock_r_link": "https://www.liveatwindyshores.com?utm_knock=r",
  "custom_knock_w_link": "https://www.liveatwindyshores.com?utm_knock=w",
  "custom_knock_z_link": "https://www.liveatwindyshores.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-TF2PL2PH",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.liveatwindyshores.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.liveatwindyshores.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.liveatwindyshores.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.liveatwindyshores.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.liveatwindyshores.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.liveatwindyshores.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "361-264-1250",
  "custom_knock_ads_link": "https://www.liveatwindyshores.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.liveatwindyshores.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fbm_link": "https://www.liveatwindyshores.com?utm_knock=fbm",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "361-264-1585",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.liveatwindyshores.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.liveatwindyshores.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.liveatwindyshores.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.liveatwindyshores.com?utm_knock=psa",
  "custom_knock_r_number": "361-264-1148",
  "custom_knock_rly_link": "https://www.liveatwindyshores.com?utm_knock=rly",
  "custom_knock_w_number": "361-264-1281",
  "custom_knock_z_number": "361-304-8427",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "361-264-1291",
  "custom_knock_amap_link": "https://www.liveatwindyshores.com?utm_knock=amap",
  "custom_knock_ar_number": "361-264-1572",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "361-264-1352",
  "custom_knock_fb_number": "361-264-1013",
  "custom_knock_fbm_title": "Facebook Marketplace",
  "custom_knock_fl_number": "361-264-1445",
  "custom_knock_gp_number": "361-273-1957",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.liveatwindyshores.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_knock_rly_title": "Rently",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "361-316-8846",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.liveatwindyshores.com?utm_knock=bcard",
  "custom_knock_bnr_number": "361-266-4473",
  "custom_knock_cfres_link": "https://www.liveatwindyshores.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_fbm_number": "361-304-7716",
  "custom_knock_lcs_number": "361-282-5488",
  "custom_knock_lgp_number": "361-314-7748",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.liveatwindyshores.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "361-264-3724",
  "custom_knock_psa_number": "361-204-4642",
  "custom_knock_rly_number": "361-309-0906",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "361-264-1438",
  "custom_knock_bandit_link": "https://www.liveatwindyshores.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.liveatwindyshores.com?utm_knock=flyers",
  "custom_knock_osoc_number": "361-301-2458",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321124211",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "361-266-3343",
  "custom_knock_cfres_number": "361-366-4894",
  "custom_knock_chatgpt_link": "https://www.liveatwindyshores.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "1ee8a62d24e16cd1",
  "custom_knock_dirmail_link": "https://www.liveatwindyshores.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "361-405-5295",
  "custom_knock_propbro_link": "https://www.liveatwindyshores.com?utm_knock=propbro",
  "custom_knock_bandit_number": "361-264-1211",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "361-264-1587",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.liveatwindyshores.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "361-314-9009",
  "custom_knock_dirmail_number": "361-264-1242",
  "custom_knock_propbro_number": "361-264-1567",
  "custom_knock_revcards_title": "Review Cards",
  "custom_self_guided_tour_url": "https://homes.rently.com/apartments-for-rent/windy%20shores/45091?source=community_link",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "361-264-1584",
  "custom_knock_maintenance_link": "https://www.liveatwindyshores.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151192642/019e8495-342d-7448-9dad-66d7cab02a57.mp4",
  "custom_knock_maintenance_number": "361-264-1439",
  "custom_ppc_tracking_phone_number": "361-273-1957"
};

export const generatedAt = '2026-10-07T17:12:07.486Z';
